import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePremium, useSession } from '../../lib/session';
import { useUI } from '../../lib/ui';

// Free users who type /scales into the address bar get bounced home with the pricing modal.
const PremiumRoute = ({ reason, children }) => {
  const navigate = useNavigate();
  const ready = useSession((s) => s.ready);
  const premium = usePremium();

  useEffect(() => {
    if (ready && !premium) {
      useUI.getState().openPricing(reason);
      navigate('/', { replace: true });
    }
  }, [ready, premium]);

  return ready && premium ? children : null;
};

export default PremiumRoute;